import { Inbox } from '@mui/icons-material';
import { useTranslation } from 'next-i18next';
import React from 'react';

export const NoBoothsFound = () => {
  const { t } = useTranslation();

  return (
    <div className="h-48 w-full grid place-items-center">
      <Inbox style={{ width: '50px', height: '50px', color: '#000000' }} />
      <p style={{ fontSize: '20px', textAlign: 'center', color: '#000000' }}>{t('booth:no-booth-found')}</p>
    </div>
  );
};
